var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgHelp = function SvgHelp(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none",
    viewBox: "0 0 20 20",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#0D2976",
    d: "M10 18a8 8 0 1 0 0-16.001A8 8 0 0 0 10 18M7.306 7.166A1.75 1.75 0 0 1 8.956 6h1.822a1.972 1.972 0 0 1 .981 3.684l-1.009.579A.75.75 0 0 1 10 11a.75.75 0 0 1-.75-.75v-.422c0-.269.144-.515.378-.65l1.384-.794a.473.473 0 0 0-.234-.88H8.956c-.106 0-.2.065-.234.165l-.013.037a.75.75 0 0 1-1.412-.5l.012-.037zM9 13a1 1 0 1 1 2 0 1 1 0 0 1-2 0"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgHelp);
export default ForwardRef;